<template>
  <div
    v-if="loading">
      <Loader />
  </div>
  <div v-else>
    <Modal v-if="comments_editor" v-on:close="comments_editor = false">
      <OrderComments
        :id="comments_editor"
        v-on:success="comments_editor = false"
      />
    </Modal>

    <Loader
      :soft="true"
      v-if="saving" />

      <TransferCall
        v-if="transfer_call"
        :id="transfer_call"
        v-on:success="updated"
        v-on:close="transfer_call = false"
      />

      <TransferOrderToStylist
        v-if="transfer_order_to_stylist"
        :id="transfer_order_to_stylist"
        :customer="transfer_customer"
        v-on:success="updated"
        v-on:close="transfer_order_to_stylist = false"
      />

      <RescheduleCall
        v-if="reschedule_call"
        :id="reschedule_call"
        v-on:success="updated"
        v-on:close="reschedule_call = false"
      />
    <div
      class="content">
    </div>
    <Table
      ref="table"
      :columns="columns"
      :rows="list"
      :filters="filters"
      :totalRecords="list.length"
      :perpage="50"
      :sortby="sortby()"
      >
      <template v-slot:filters>
        <div v-if="tab === 'sp'" class="margin-bottom" style="text-align: right;">
          Pending AI Finalization:
          {{ data.stats.ai_pending_processing }}
        </div>
        <button
          v-on:click="load"
          :disabled="saving"
          class="small gray">Refresh</button>
      </template>
    </Table>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import OrderComments from '@/components/orders/Comments.vue'
import TransferCall from '@/components/scheduled-calls/Transfer.vue'
import TransferOrderToStylist from '@/components/scheduled-calls/TransferOrderToStylist.vue'
import RescheduleCall from '@/components/scheduled-calls/Reschedule.vue'

export default {
  props: {
    tab: {
      type: String,
      required: true
    },
    stylist: {
      default: null
    },
    locales: {
      type: Object
    }
  },
  components: {
    OrderComments,
    TransferCall,
    TransferOrderToStylist,
    RescheduleCall
  },
  watch: {
    stylist () {
      this.load()
      for (var stylist of this.getStylists) {
        if (stylist.id == this.stylist) {
          this.$emit('change-stylist', stylist)
        }
      }
    },
    tab () {
      this.load()
    }
  },
  data: () => ({
    data: {},
    loading: false,
    saving: false,
    comments_editor: null,
    reschedule_call: false,
    transfer_call: false,
    transfer_order_to_stylist: false,
    transfer_customer: null,
    picking_id: null
  }),
  computed: {
    ...mapGetters([
      'getStylists'
    ]),
    filters () {
      if (this.tab != 'up_for_grabs') {
        return {}
      }

      return {
        age: {
          name: 'Age',
          mode: 'number'
        }
      }
    },
    list () {
      var list = []
      for (var row of this.data.list) {
        if (
          (this.tab == 'up_for_grabs' || this.stylist == 'all') &&
          !this.locales[row.locale_id]
        ) {
          continue
        }

        row.bgColor = this.getColor(row)

        row.cust = {
          type: 'customer',
          customer: row.customer
        }

        // This record make it possible to search for the full name
        row.full_name = row.customer.first_name + ' ' + row.customer.last_name

        if (row.call) {
          row.call_at = row.call.call_at
        }

        if (row.stylist) {
          row.stylist_name = row.stylist.firstname + (row.stylist.lastname ? ' ' + row.stylist.lastname.substr(0, 1) : '')
        }

        row.received_at = row.order_date

        row.menu = this.menu(row)

        if (row.id) {
          row.order = {
            type: 'order',
            order_id: row.id
          }
        } else {
          row.order = '[ No order ]'
        }

        list.push(row)
      }
      return list
    },
    columns () {
      var columns = {}

      columns.locale_id = {
        name: 'Country',
        type: 'flag'
      }

      columns.order = {
        name: 'Order'
      }

      if (['up_for_grabs'].indexOf(this.tab) >= 0) {
        columns.order_date = {
          name: 'Order date',
          type: 'datetime'
        }
      }

      columns.cust = {
        name: 'Customer'
      }

      if (['calls'].indexOf(this.tab) >= 0) {
        columns.call_at = {
          name: 'Call at',
          type: 'datetime',
          sortable: {
            name: 'Call'
          }
        }
      }

      if (['calls', 'in_progress', 'sp', 'outstanding'].indexOf(this.tab) >= 0) {
        columns.stylist_name = {
          name: 'Stylist'
        }
      }

      if (['in_progress', 'up_for_grabs'].indexOf(this.tab) >= 0) {
        columns.size = {
          name: 'Size'
        }
      }

      if (['in_progress', 'up_for_grabs', 'sp', 'outstanding'].indexOf(this.tab) >= 0) {
        columns.stylist_comment = {
          name: 'Stylist comment',
          width: 15
        }
      }

      if (['sp', 'outstanding'].indexOf(this.tab) < 0) {
        columns.customer_comment = {
            name: 'Customer comment',
            width: 15
          }
      }

      if (['in_progress'].indexOf(this.tab) >= 0) {
        columns.received_at = {
          name: 'Picked date',
          type: 'datetime'
        }
      }

      if (['sp', 'outstanding'].indexOf(this.tab) >= 0) {
        columns.sneak_peek_sent_at = {
          name: 'Sent at'
        }
        columns.feedback_given_at = {
          name: 'Feedback given',
          sortable: {
            name: 'Feedback given at'
          }
        }
      }

      return columns
    }
  },
  methods: {
    sortby () {
      if (this.tab == 'calls') {
        setTimeout(() => this.$refs.table.setSorting({
          column: 'call_at',
          descending: false
        }), 100)

        return true
      }

      if (this.tab == 'in_progress') {
        setTimeout(() => this.$refs.table.setSorting({
          column: 'received_at',
          descending: false
        }), 100)
      }

      if (['sp', 'outstanding'].indexOf(this.tab) >= 0) {
        setTimeout(() => this.$refs.table.setSorting({
          column: 'feedback_given_at',
          descending: false
        }), 100)

        return true
      }

      return false
    },
    updated () {
      this.reschedule_call = false
      this.transfer_call = false
      this.transfer_order_to_stylist = false

      this.load()
    },
    menu (row) {
      var menu = []

      if (
        ['calls'].indexOf(this.tab) >= 0 &&
        row.call
      ) {
        menu.push({
          name: 'Transfer',
          onClick: (row) => (this.transfer_call = row.scheduled_call_id)
        })
      }

      if (
        ['in_progress', 'sp'].indexOf(this.tab) >= 0
      ) {
        menu.push({
          name: 'Transfer',
          onClick: (row) => (this.transfer_order_to_stylist = row.id)
        })
      }

      if (['calls'].indexOf(this.tab) >= 0) {
        menu.push({
          name: 'Reschedule',
          onClick: (row) => (this.reschedule_call = row.scheduled_call_id)
        })

        menu.push({
          name: 'Cancel',
          onClick: (row) => this.cancel(row)
        })
      }

      menu.push({
        name: 'Comments',
        onClick: (row) => this.comments(row)
      })

      switch (row.order_type_id) {
        case 1:
          menu.push({
            name: 'Go to styling',
            url: `/#/stylings/process?id=${row.id}&key=${row.key}`
          })
          break
        case 3:
          if (!row.styling) {
            menu.push({
              name: 'Pick',
              onClick: row => (this.pick(row.id))
            })
          } else {
            menu.push({
              name: 'Go to styling',
              url: `/#/stylings/process?id=${row.styling.styling_order_id}&key=${row.key}`
            })
          }
          break
      }

      return menu
    },
    pick (id) {
      this.picking_id = id

      Vue.api.get(
        '/order/' + id + '/pick/preconditions',
        {},
        {
          before: () => (this.saving = true),
          always: () => (this.saving = false),
          callback: (data) => this.precondition(data)
        }
      )
    },
    precondition (data) {
      var id = data.id ? data.id : data.ID

      if ((data.message && confirm(data.message)) || !data.message) {
        Vue.api.post(
          '/order/' + this.picking_id + '/pick',
          {},
          {
            always: () => (this.saving = false),
            callback: (data) => this.picked(data)
          }
        )
      }
    },
    picked (data) {
      const id = data.id || data.ID
      const key = data.key
      this.$router.push({
        path: '/stylings/process',
        query: {
          id,
          key
        }
      })
    },
    cancel (row) {
      if (confirm('Are you sure?')) {
        Vue.$api.delete(
          '/scheduled-call/' + row.scheduled_call_id,
          {},
          {
            before: () => (this.saving = true),
            always: () => (this.saving = false),
            callback: (data) => this.load()
          }
        )
      }
    },
    comments (row) {
      this.comments_editor = row.id ? row.id : row.ID
    },
    getColor (row) {
      // Abandoned: Orange
      // Surprise box: Blue
      // Quiz not completed: Pink

      if (this.tab === 'calls') {
        if (row.sneak_peek_sent_at || row.sneak_peek_state != 'not_sent') {
          return 'pink'
        }
        return '#f2f2f2'
      }

      if (['sp', 'outstanding'].indexOf(this.tab) == -1) {
        return '#fff'
      }

      if (row.flow == 'abandoned') {
        return '#eec982'
      } else if (row.surprise_box_requested_at) {
        return '#B6D7FF'
      } else if (!row.quiz_completed_at && this.tab === 'outstanding') {
        return '#ffebeb'
      }

      return '#F2F2F2'
    },
    load () {
      const stylist = (!this.stylist || this.stylist == 'all') ? '' : this.stylist
      Vue.$api.get('/preshipping/tabs/' + this.tab + '?stylist_id=' + stylist, {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => {
          this.data = data
          setTimeout(() => this.initFilter(), 10)
        }
      })
    },
    initFilter () {
      if (this.tab === 'up_for_grabs') {
        this.$refs.table.setFilter({
          age: {
            mode: 'number',
            operator: '>',
            value: 48
          }
        })
      }
    }
  },
  created () {
    this.load()
  }
}
</script>
